export const SYSTEM_STATUS = {
    AVAILABLE: 'available',
    MAINTENANCE: 'maintenance',
};
